<template>
  <section>
    <div class="row justify-content-end">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ul class="breadcrumb">
            <li class="breadcrumb-item h3 font-weight-bold mb-0">
              <router-link
                v-bind:to="{
                  name: 'program-study/index',
                  params: { type: course.department.courseCategoryID },
                }"
              >
                Prodi Kuliah {{ course.department.courseCategory.name }}
              </router-link>
            </li>
            <li
              class="breadcrumb-item active font-weight-medium"
              aria-current="page"
            >
              {{ course.name }}
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="row mb-5 mt-4" v-if="course.image">
      <div class="col">
        <img
          v-bind:src="course.imageUrl"
          class="img-fluid w-100"
          v-bind:alt="course.name"
        />
      </div>
    </div>
    <div class="row justify-content-end mb-4">
      <div class="col">
        <h3 class="text-danger font-weight-bold">
          {{ course.name }}
        </h3>
      </div>
      <div class="col-auto" v-if="roleElligible()">
        <router-link
          v-bind:to="{
            name: 'program-study/edit',
            params: { type: course.department.courseCategoryID, id: course.id },
          }"
          class="btn btn-danger btn-sm px-5"
        >
          Edit Prodi
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="row">
          <div class="col">
            <div class="card shadow-sm mb-4 border-0">
              <div class="card-header background-primary">
                <div class="row">
                  <div class="col">
                    <span class="h4 font-weight-medium text-white mb-0">
                      Gambaran Umum
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div v-html="course.description"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card shadow-sm mb-4 border-0">
              <div class="card-header background-primary">
                <div class="row">
                  <div class="col">
                    <span class="h4 font-weight-medium text-white mb-0">
                      Prospek Kerja
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div v-html="course.prospect"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="card shadow-sm mb-4 border-0">
          <div class="card-header background-primary">
            <div class="row">
              <div class="col">
                <span class="h4 font-weight-medium text-white mb-0">
                  Mata Kuliah yang Dipelajari
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-html="course.subject"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card shadow-sm mb-4 border-0">
          <div class="card-header background-primary">
            <div class="row">
              <div class="col">
                <span class="h4 font-weight-medium text-white mb-0">
                  PTN & Jurusan Terkait
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div id="table-primary" class="table-responsive px-2">
              <table class="table">
                <thead>
                  <tr class="text-danger font-weight-bold">
                    <th scope="col" class="bg-white">Nama PTN</th>
                    <th scope="col" class="bg-white">Jurusan</th>
                    <th scope="col" class="bg-white">NBA</th>
                    <th scope="col" class="bg-white">Akreditasi</th>
                    <th scope="col" class="bg-white">Daya Tampung 2025</th>
                    <th scope="col" class="bg-white">Peminat 2024</th>
                  </tr>
                </thead>
                <tbody class="font-weight-medium">
                  <tr
                    class="shadow-sm"
                    v-for="universityCourse in course.universityCourses"
                  >
                    <td class="text-center py-4">
                      <span class="text-loading">{{
                        universityCourse.university.name
                      }}</span>
                    </td>
                    <td class="py-4">
                      <span class="text-loading">{{
                        universityCourse.name
                      }}</span>
                    </td>
                    <td class="py-4">
                      <span v-if="universityCourse.nba" class="text-loading">{{
                        universityCourse.nba
                      }}</span>
                      <i class="fa fa-minus" v-else></i>
                    </td>
                    <td class="py-4">
                      <span
                        class="text-loading"
                        v-if="universityCourse.accreditation"
                        >{{ universityCourse.accreditation }}</span
                      >
                      <i class="fa fa-minus" v-else></i>
                    </td>
                    <td class="py-4">
                      <span
                        class="text-loading"
                        v-if="universityCourse.graduates"
                        >{{ universityCourse.graduates }}</span
                      >
                      <i class="fa fa-minus" v-else></i>
                    </td>
                    <td class="py-4">
                      <span
                        class="text-loading"
                        v-if="universityCourse.graduates"
                        >{{ universityCourse.keketatan }}</span
                      >
                      <i class="fa fa-minus" v-else></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
/**
 * @param {Object} tryout
 */
export default {
  name: "ProgramStudyView",
  computed: mapState(["profile"]),
  data() {
    return {
      course: { department: { courseCategory: {} } },
    };
  },
  methods: {
    roleElligible() {
      return this.profile.isAdmin;
    },
  },
  created() {
    this.axios
      .get(process.env.API_URL + "/course/" + this.$route.params.id)
      .then((response) => {
        this.course = response.data.data;
        if (
          this.course.department.courseCategoryID !==
          parseInt(this.$route.params.type)
        ) {
          this.$router.replace({
            name: "error",
            params: { code: 404, message: "Program Study not found" },
          });
        }
        document.title =
          "Prodi " + this.course.name + " - " + process.env.APP_NAME;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/program-study/View.vue